import { Settings2 } from "lucide-react";

/** Neutral panel shown at `/settings` before a specific leaf is selected. */
const SettingsLanding = () => (
	<div className="flex min-h-[320px] flex-col items-center justify-center text-center">
		<Settings2 className="mb-3 h-10 w-10 text-gray-300" />
		<p className="text-base font-medium text-gray-700">Välj en inställning</p>
		<p className="mt-1 max-w-sm text-sm text-gray-500">
			Välj en inställning i menyn till vänster för att börja, eller sök efter en specifik
			inställning.
		</p>
	</div>
);

export default SettingsLanding;
